<template>
      <ob-modal2 :show.sync="show" width="600px" :backdrop="false">
            <template slot="modal-title">
                  <h3 class="upload-document_heading">Share Work Auth History</h3>
            </template>
            <template slot="modal-body">
                  <div class="compose-mail-container">
                        <div class="row m0">
                             <div class="SubmitPopupTab">
                                <div class="col-md-1 padding-0"> <label>From:</label> </div>
                                <div class="col-md-11">{{empName}}</div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="row">
                              <div class="col-md-12">
                                    <div class="to-address-div clearfix">
                                          <label>To</label>
                                          <div class="to-adddress-select">
                                          <ob-select2 :options="options" v-model="mail.toAddress" :multiple="true"></ob-select2>
                                          </div>
                                          <div class="right-cc-div" v-if="!CCSection || !BCCSection">
                                          <label @click="showCC" v-if="!CCSection">Cc</label>
                                          <label @click="showBCC" v-if="!BCCSection">Bcc</label>
                                          </div>
                                          <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.toAddress.$dirty && !$v.mail.toAddress.required"> Please enter To Address</span>
                                    </div>
                              </div>
                              </div>
                              <div class="row" v-if="CCSection">
                              <div class="col-md-12">
                                    <div class="cc-address-div clearfix">
                                          <label>Cc</label>
                                          <div class="to-adddress-select">
                                          <ob-select2 :options="options" v-model="mail.ccAddress" :multiple="true"></ob-select2>
                                          </div>
                                          <a href="javascript:;" class="cc-close-icon" @click="showCC">X</a>
                                          <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.ccAddress.$dirty && !$v.mail.ccAddress.requiredIf"> Please select Cc Address</span>
                                    </div>
                              </div>
                              </div>
                              <div class="row" v-if="BCCSection">
                              <div class="col-md-12">
                                    <div class="bcc-address-div clearfix">
                                          <label>Bcc</label>
                                          <div class="to-adddress-select">
                                          <ob-select2 :options="options" v-model="mail.bccAddress" :multiple="true"></ob-select2>
                                          </div>
                                          <a href="javascript:;" class="cc-close-icon" @click="showBCC">X</a>
                                          <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.bccAddress.$dirty && !$v.mail.bccAddress.requiredIf"> Please enter Bcc Address</span>
                                    </div>
                              </div>
                              </div>
                              <div class="row">
                              <div class="col-md-12">
                                    <div class="subject-div clearfix">
                                          <label>Subject</label>
                                          <input type="text" class="subject-input" v-model="mail.subject">
                                          <span class="email__subject ob-vuelidate_error-msg pL0" v-if="$v.mail.subject.$dirty && !$v.mail.subject.required"> Please enter subject</span>
                                    </div>
                              </div>
                              </div>
                              <div class="row">
                                <div class="col-md-12">
                                    <div class="mail-signature-div">
                                        <ob-button type="secondary" @click="uploadAttachments"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/mail/attachment.svg`" style="width:9px;height:13px;margin-right:8px">Attach File</ob-button>
                                        <p style="font-style: italic; margin: 5px; font-size: 12px;">We accept either docs, pdf, images and batchfiles upto 25MB.</p>
                                    </div>
                                </div>
                            </div>
                              <div class="row">
                                <div class="col-md-12">
                                      <div class="mail-body-content" >
                                            <textarea :id="tinyMceId" ref="tinymce"></textarea>
                                            <span class="email__subject ob-vuelidate_error-msg pL0" v-if="$v.mail.bodyContent.$dirty && !$v.mail.bodyContent.required"> Please enter body content</span>

                                      </div>
                                </div>
                              </div>
                              <div class="row">
                              <div class="col-md-12">
                                    <div class="attachments-view">
                                          <template>
                                                <span id="task-title">
                                                {{this.attachmentLink.Name}}
                                                </span>
                                          </template>
                                    </div>
                                    <div>
                                        <template v-for="(item, indexE) in mail.attachments">
                                            <div class="attachments-view">
                                                <template>
                                                    <span id="task-title">
                                                    {{getFileNameEdit(item.Name)}}
                                                    </span>
                                                </template>
                                                <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px;margin-right: 10px;">
                                                <span class="cross-mark" @click="removeAttachedFile(indexE)" style="font-size: 11px; padding: 2px 5px;cursor:pointer;" >&#10006;</span></span>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="attachmentDiv" style="padding:5px 10px">
                                        <ob-upload-attachment ref="upload" @error-msg="IsInvalidFileEdit" @file-inProgress="InProgressEdit" @file-complete="onComplete" :validation="ValidationType" :end-point="EndPoint" :type="1" :IsFileExists="attachmentFileName" :attach-file.sync="attachFile" >
                                            <template slot="file-text">
                                                <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                                            </template>
                                        </ob-upload-attachment>
                                    </div>

                              </div>
                              </div>

                  </div>
            </template>
            <template slot="modal-footer">
                  <ob-button type="secondary" @click="CancelMail">Cancel</ob-button>
                  <ob-button type="primary" @click="sendMail">Send</ob-button>
            </template>
      </ob-modal2>
</template>
<script>
    import tinyMCE from "tinymce";
    import { required, email, numeric, url, requiredIf } from 'vuelidate/lib/validators'
    import c from '@/components/Core/constants.js'
    import jquery from "jquery";
    import utils from '@/components/Core/utils.js'

    export default {
           props: [
            "ShareDocumentPopup",
            "openModal",
            "attachmentLink",
            "empName"
        ],
        data(){
            return{
                CCSection:false,
                BCCSection: false,
                show: false,
                options: {
                    ajax: {
                        type: 'PUT',
                        url: function (params) {
                            return `${c.APIBASEURL}/Email/ComposeMailSuggestions?email=${params.term}`
                        },
                        delay: 250,
                        data: function (params) {
                            var query = {

                            }
                            return query;
                        },
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                        },
                        processResults: function (data) {
                            try {
                                data = JSON.parse(data);
                            } catch(ex) {

                            }
                            let results = []
                            if (data !== null) {
                                data.forEach((e) => {
                                    results.push({
                                        id: e.Email,
                                        text: e.Email
                                    })
                                })
                            }

                            return {
                                results: results
                            };
                        }
                    },
                    placeholder: '',
                    tags: true,
                    selectOnClose: true,
                    tokenSeparators: [',', ' '],
                    minimumInputLength: 3,
                    createTag: function (params) {
                        var expr = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var term = params.term
                        if (expr.test(term) == true) {
                            return {
                                id: term,
                                text: term
                            };
                        }
                        else
                            return null;
                    }
                },
                mail: {
                    toAddress: [],
                    ccAddress: [],
                    bccAddress: [],
                    subject: '',
                    bodyContent:'',
                    attachments:[]
                },

                tinyMceId: 'editor_' + __.random(10000, 99999),
                currentBtnAction: '',
                attachmentDiv:false,
                attachFile:false,
                attachmentFileName: [],
                EndPoint: `${c.APIBASEURL}/File/FileUpload`,
                ValidationType: {
                    Rules: {
                        //Type: ["pdf", "zip", "xls", "xlsx", "doc", "docx", "png", "jpeg", "jpg", "svg", "csv", "gif","bmp",'JPG','JPEG','PNG'],
                        Type:['exe','js','bat'],
                        Size: 26214400, // In Bytes
                        multiplefiles: true,
                        excludeList:true
                    },
                    Messages: {
                        Type: "Please upload valid file formats",
                        Size: `Please upload a file which is less than 25MB`,
                    },

                },
            }
        },
        validations() {
            return{
                mail: {
                    toAddress: {
                        required
                    },
                    ccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.CCSection
                        })
                    },
                    bccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.BCCSection
                        })
                    },
                    subject: {
                        required
                    },
                    bodyContent:{
                         required
                    }
                }
            }
        },
        mounted() {
            this.tinymcePlugin()
        },
        watch: {
            openModal(val) {
            this.show = val;
            this.employeeId =loggedInUserObj.empId;
            },
            show(val) {
                  this.$emit('update:openModal', val)
            },

            Description(val) {
                Vue.set(this.mail, 'bodyContent', val)
            }
        },
        created() {
        },
        methods:{
            getFileNameEdit(item){
                var filename = utils.I9URL2FileName(item);
                return filename
            },
            uploadAttachments() {
                setTimeout(() => {
                    this.$refs.upload.uploadNew();
                    //this.attachFile = true
                }, 1000)
                this.attachmentDiv=true
            },
            removeAttachedFile(index){
                 this.mail.attachments.splice(index,1)
            },
            IsInvalidFileEdit(error){
                if(error != '')
                {
                    this.$message({
                    type: 'error',
                    message: error
                    });
                }
             },
             InProgressEdit(){
               // this.$loading({'loadingText': 'Loading...'})
                this.attachmentDiv = true
             },
            onComplete(res) {
                let name = []
                this.mail.attachments.forEach((a)=>{
                    name.push(a.Name)
                })
                res.forEach((e)=>{
                    if(!name.includes(e.Name)){
                        let attachmentObj = {
                            'Name':e.Name,
                            'Url':e.response.Url
                        }
                        this.mail.attachments.push(attachmentObj)
                    }
                })
                this.attachmentDiv=false

            },
            showCC(){
                this.CCSection = !this.CCSection
            },
            showBCC(){
                this.BCCSection = !this.BCCSection
            },
            getmailParams() {
                let mailParams = {
                    "Subject": this.mail.subject,
                    "CCList":'' ,
                    "BCCList": '',
                    "ToList": this.mail.toAddress,
                    "Body": this.mail.bodyContent,
                }
                if(this.mail.ccAddress != null && this.mail.ccAddress.length > 0){
                    mailParams.CCList = this.mail.ccAddress
                }
                if(this.mail.bccAddress != null && this.mail.bccAddress.length > 0){
                    mailParams.BCCList = this.mail.bccAddress
                }
                let attachmentUrl = []
                attachmentUrl.push(this.attachmentLink.Url)
                this.mail.attachments.forEach((e) => {
                    attachmentUrl.push(e.Url)
                })
                mailParams.Attachments = attachmentUrl
                return mailParams
            },
            CancelMail() {
                  this.resetData()
                  this.$v.mail.$reset()
                  this.show = false
                  this.$emit('composeMail')
            },
            sendMail() {
                this.currentBtnAction = 'Send'
                this.$v.mail.$touch()
                if (this.$v.mail.$invalid != true) {
                    this.$loading({'loadingText':'Sending mail..'})
                    ajax.post(`/Employee/${this.employeeId}/ShareEmployeeWorkAuthHistory`, this.getmailParams(), (res) => {
                        this.resetData()
                        this.$v.mail.$reset()
                        this.show = false
                        this.$loading({}).close()
                        if (res.data.State == true) {
                            this.$message({
                                type: 'success',
                                message: 'Your mail has been sent successfully!'
                            })
                        }
                        else {
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            })
                        }

                    })
                }
            },
            resetData() {
                this.mail.toAddress = []
                this.mail.ccAddress = []
                this.mail.bccAddress = []
                this.mail.attachments = []
                this.mail.subject = ''
                this.mail.bodyContent = ''
                this.Description = ''
                tinymce.get(this.tinyMceId).setContent('')


            },
            tinymcePlugin() {
                var vm = this
                tinyMCE.init({
                    selector: "#" + vm.tinyMceId,  // change this value according to your HTML
                    plugins: "autoresize",
                    menubar: false,
                    height: 250,
                    max_height:250,
                    paste_data_images: true,
                    image_dimensions: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'textcolor colorpicker',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                        'insertdatetime media nonbreaking save table contextmenu directionality',
                        'emoticons template paste textcolor colorpicker textpattern'
                    ],
                    setup: function (ed) {
                        ed.on('init', function () {
                            this.getDoc().body.style.fontSize = '14px';
                            this.getDoc().body.style.fontFamily = 'Open Sans';
                        });
                        ed.on('change', function () {
                            vm.mail.bodyContent = ed.getContent();
                            ed.save();
                        });
                        ed.on('blur', function () {
                            vm.mail.bodyContent = ed.getContent();
                        });
                    },
                    toolbar1: ' bold | italic | underline | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | fontselect | fontsizeselect | link image',
                    style_formats: [
                        { title: 'Line height 20px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '20px', padding: '0px' } },
                        { title: 'Line height 30px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '30px', padding: '3px' } }
                    ],
                    fontsize_formats: '8px 10px 12px 14px 18px',
                    font_formats: "Arial=arial,helvetica,sans-serif;" +
                    "Georgia=georgia,palatino;" +
                    "Helvetica=helvetica;" +
                    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                    "Verdana=verdana,geneva;" +
                    "Times New Roman=times new roman,times;" + "Open Sans=Open Sans, sans-serif;",
                    image_advtab: true,
                    file_picker_callback: function (callback, value, meta) {
                        if (meta.filetype == 'image') {
                            $('#upload').trigger('click');
                            $('#upload').on('change', function () {
                                var file = this.files[0];
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    callback(e.target.result, {
                                        alt: ''
                                    });
                                };
                                reader.readAsDataURL(file);
                            });
                        }
                    }
                });
            },
        }
    }
</script>
<style lang='scss' scoped>
@import "~styles/framework/vue-utils";
.fixed-height{
    height: 100%;
}
.attachments-view{
    margin-bottom: 5px;
    color:#4A90E2;
    margin-left: 0px;
    border: 1px solid #4A90E2 !important;
    background: #e6eff9 !important;
    padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: bold;
    float: left;
    margin-right: 2%;
    margin-top: 15px;

}

.compose-mail-container{
    width: auto;
    margin: 1% auto 0 auto;
    height: auto;
    background-color: #fff;
    .compose-mail-heading{
        background-color: $ob-brand-primary;
        p{
            margin: 0;
            padding: 15px 20px;
            color: #fff;
            font-size: 11px;
            font-weight: 600;
        }
    }
    .to-address-div{
        border-bottom: 1px solid #c2c2c2;
        padding: 10px 20px;
        label{
            color: #030303;
            font-size: 11px;
            font-weight: 600;
            margin-bottom: 0;
            width:50px;
            display:inline-block;
        }
        .to-adddress-select{
            width:80%;
            display:inline-block;
        }
        .right-cc-div{
            display:inline-block;
            label{
                display: inline-block;
                font-size: 11px;
                font-weight: 600;
                margin:0 0 0 5px;
                cursor: pointer;
                width:auto;
            }
        }
    }
    .cc-close-icon{
        float: right;
        display:inline-block;
        font-size: 12px;
        font-weight: 600;
        color:#030303;
    }
    .cc-address-div{
        @extend .to-address-div
    }
    .bcc-address-div{
        @extend .to-address-div
    }
    .subject-div{
        @extend .to-address-div;
        label{
            margin: 10px 0 0 0;
        }
        .subject-input{
            width:90%;
            padding: 10px;
            border: 0;
        }
    }
    .mail-signature-div{
        @extend .to-address-div
    }
    .mail-body-content{

    }
    .mail-footer-div{
        padding: 10px 20px;
        background-color: #f4f4f4;
    }
    .file-attachment-container{
        padding:10px 5px;
    }
    .mail-details__signature {
        position: absolute;
        background-color: #fff;
        z-index: 1;
        width: 176px;
        top: 49px;
        left: 37px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        &:before, &:after{
            bottom: 100%;
            right: 14%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        &:before{
                border-color: transparent;
                border-bottom-color: #e5e5e5;
                border-width: 10px;
                margin-left: -13px;
        }
        &:after {
                border-color: hsla(0,0%,100%,0);
                border-bottom-color: #fff;
                border-width: 9px;
                margin-left: -12px;
        }
        ul{
            list-style-type:none;
            padding: 0;
            li{
                font-size: 12px;
                padding: 10px;
                color:#848484;
                font-weight:600;
                cursor:pointer;
                text-align:left;
                border-bottom:1px solid #eee;
                &:last-child{
                                border:none;
                            }
                .address{
                    width: 65px;
                    display: inline-block;
                }
                &:hover{
                    background:#f0f0f0;
                }
                &.active{
                    background:#f0f0f0;
                }
            }
        }
    }
    .compose-mail__error{
        padding-left:50px;
    }
}
</style>
<style>
    .compose-mail-container .mail-body-content .mce-btn-group .mce-btn button{
        padding: 4px 5px;
    }
    .compose-mail-container .mail-body-content .mce-listbox .mce-caret{
        right: 0 !important;
    }
    .compose-mail-container .mail-body-content .mce-panel{
        border-bottom-width: 0px !important;
        border-right-width: 0px !important;
        border-left-width: 0px !important;
    }
    .to-adddress-select .select2-container--onblick .select2-selection.select2-selection--multiple{
        border: 0 !important;
    }
    .compose-mail-container .ob-vuelidate_error-msg {
        font-size: 12px;
        display:block;
    }

    .compose-mail-container .email__subject {
        padding-left: 50px;
    }
    .compose-mail-container .mail-details__signature ul li.active p {
        background: #f0f0f0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Profile/ShareWorkAuthHistory.vue